import { render } from "./Carousel1.vue?vue&type=template&id=46e2a804"
import script from "./Carousel1.vue?vue&type=script&lang=ts"
export * from "./Carousel1.vue?vue&type=script&lang=ts"

import "./Carousel1.vue?vue&type=style&index=0&id=46e2a804&lang=scss"
script.render = render

export default script